import axios from "axios";
import config from "../config";
import { TokenContext } from "../context/TokenContext";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const afasFetcher = async (input: [string, any, string]) => {
  const [path, queryStringParameters, token] = input;
  return axios
    .get(
      `${
        process.env.REACT_APP_ENV === "development" || process.env.NODE_ENV === "development"
          ? config.BASE_URL_DEV
          : config.BASE_URL
      }${path}`,
      {
        headers: {
          Authorization: token,
        },
        params: queryStringParameters,
      }
    )
    .then((res) => res.data);
};

function useAfasData(
  path: string,
  queryStringObj = {},
  options = {
    enabled: true,
  }
): {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  status: "error" | "success" | "loading";
  isLoading: boolean;
  refetch: (options: { throwOnError: boolean; cancelRefetch: boolean }) => Promise<UseQueryResult>;
  errorMessage: string | undefined;
  statusCode: number;
  errorType: string;
  error: string | undefined;
} {
  const token = useContext(TokenContext);
  const { currentLang } = useContext(LanguageContext);
  queryStringObj = { ...queryStringObj, lang: currentLang };

  // eslint-disable-next-line no-unused-vars
  const { data, error, isLoading, status, refetch } = useQuery({
    queryKey: [path, queryStringObj, token],
    queryFn: () => afasFetcher([path, queryStringObj, token]),
    enabled: options.enabled && !!token,
  });

  const errorAsError = error as Error;

  let errorMessage;
  let errorType = "";
  let statusCode = 200;

  if (errorAsError) {
    errorType = "UnexpectedError";
    statusCode = 400;
    errorMessage = `ERROR ${errorAsError.message}`;
  }
  return {
    data,
    status,
    isLoading,
    refetch,
    errorMessage,
    statusCode,
    errorType,
    error: errorMessage,
  };
}

export default useAfasData;
